import { z } from 'zod';

export const OperationStatusSchema = z.object({
  success: z.boolean(),
});
export type IOperationStatustDto = z.infer<typeof OperationStatusSchema>;
